import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { isObject } from '../isObject';
import { ErrorResponse, ServerError } from './ErrorResponse';
export class PaymentMethodErrorResponse {
    isStripeError() {
        return this.stripeError() != null;
    }
    isPlaidError() {
        return this.error.hasServerError(ServerError.BankTransferAccountBlocked);
    }
    removeMessage(texts) {
        if (this.error.hasErrorMessageIncluding('used by other approved relationships')) {
            return texts.paymentMethod.usedInOtherApprovedAgreements();
        }
        if (this.error.hasServerError(ServerError.FundingSourceTiedToOpenAdHocInvoice)) {
            return texts.paymentMethod.tiedToOpenAdHocInvoice();
        }
        return null;
    }
    isNotVerifiedRejection() {
        return this.error.hasServerError(ServerError.FundingSourceNotVerified);
    }
    connectMessage(texts) {
        return this.isNotVerifiedRejection() ? texts.paymentMethod.notFullyVerified() : texts.paymentMethod.failedToConnect();
    }
    stripeError() {
        const body = this.error.body;
        if (isObject(body) && 'error' in body && typeof body.error === 'string') {
            try {
                const parsed = JSON.parse(body.error);
                return this.stripeErrorKeys.every((key)=>key in parsed) ? parsed : null;
            } catch (unused) {
                return null;
            }
        } else {
            return null;
        }
    }
    constructor(error){
        _define_property(this, "error", void 0);
        _define_property(this, "stripeErrorKeys", [
            'code',
            'doc_url',
            'status',
            'message',
            'param',
            'request_id',
            'type'
        ]);
        this.error = error instanceof ErrorResponse ? error : new ErrorResponse(error);
    }
}
